<div>
  <dl class="divide-y divide-gray-100">
    @for (item of config().items; track item.id || item) {
      <div class="py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
        <dt class="text-sm font-medium leading-6 text-gray-900">
          {{ item.title }}
        </dt>
        @if (item.type === DetailsListItemType.Text) {
          <dd [class]="item.styleClass || 'mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0'">
            {{ item.content }}
          </dd>
        }
        @if (item.type === DetailsListItemType.Date) {
          <dd [class]="item.styleClass || 'mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0'">
            {{ item.content | date }}
          </dd>
        }
        @if (item.type === DetailsListItemType.Decimal) {
          <dd [class]="item.styleClass || 'mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0'">
            {{ item.content | number: '1.2-2' }}
          </dd>
        }
        @if (item.type === DetailsListItemType.Image) {
          <img data-automationid="details-list-row-image" class="flex-auto bg-gray-50" [src]="item.content" alt="" />
        }
      </div>
    }
  </dl>
</div>
